import Contact from '../../entities/Contact/ui/Contact';
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo';
import styles from './ContactPage.module.scss';

export const ContactPage = () => {
    return(
        <div className={styles.contact}>
            <Contact/>
            <FooterInfo/>
        </div>
    )
}